import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { RotateCcw, ArrowRight } from "lucide-react";
import useSeo from "../lib/useSeo";

export default function CheckoutCancelPage() {
    useSeo({
        title: "Checkout Cancelled",
        description:
            "Your Discovery Session checkout was cancelled. Come back any time — we saved your seat.",
    });

    return (
        <main
            data-testid="checkout-cancel-page"
            className="min-h-[80vh] flex items-center justify-center px-6 py-20"
        >
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8 }}
                className="w-full max-w-2xl frame-gold p-10 md:p-14 text-center"
            >
                <RotateCcw className="w-8 h-8 text-[#D4AF37] mx-auto mb-6" />
                <div className="eyebrow mb-3">Checkout cancelled</div>
                <h1 className="font-serif text-4xl md:text-5xl leading-tight">
                    No worries —{" "}
                    <span className="text-gold-gradient italic">your seat is still here</span>.
                </h1>
                <p className="text-[#cfcfcf] mt-6 max-w-lg mx-auto leading-relaxed">
                    You weren't charged. Whenever you're ready, come back and we'll pick right
                    up where you left off. If you have any questions before booking, just reach out.
                </p>
                <div className="mt-10 flex flex-wrap justify-center gap-4">
                    <Link
                        to="/#discovery"
                        className="btn-gold"
                        data-testid="cancel-retry-btn"
                    >
                        Try again <ArrowRight className="w-3.5 h-3.5" />
                    </Link>
                    <Link
                        to="/"
                        className="btn-ghost-gold"
                        data-testid="cancel-home-btn"
                    >
                        Return to the Hub
                    </Link>
                </div>
            </motion.div>
        </main>
    );
}
